// https://chakra-ui.com/docs/styled-system/responsive-styles
export const breakpoints = {
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1280,
  '2xl': 1536,
};
